import {Typography} from '~library/atoms/Typography';

import './Section.sass';

type SectionProps = {
  children: React.ReactNode;
  title?: string;
};

export const Section = ({children, title}: SectionProps) => {
  return (
    <div className="other-gift-options__section">
      {title && (
        <Typography variant="paragraph1" semibold>
          {title}
        </Typography>
      )}
      <div className="other-gift-options__section__content">{children}</div>
    </div>
  );
};
